(() => {
  const enhance = (scope = document) => {
    scope.querySelectorAll('[data-wearilo-info]').forEach((shell) => {
      if (shell.dataset.wiReady) return;
      shell.dataset.wiReady = 'true';
      const article = shell.querySelector('[data-wi-article]');
      const toc = shell.querySelector('[data-wi-toc]');
      const links = shell.querySelector('[data-wi-toc-links]');
      if (!article || !toc || !links) return;
      const headings = [...article.querySelectorAll('h2')].filter((heading) => heading.textContent.trim());
      if (headings.length < 3) return;
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `wi-section-${index + 1}`;
        heading.tabIndex = -1;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        const number = document.createElement('span');
        number.className = 'wi-toc-number';
        number.textContent = String(index + 1).padStart(2, '0');
        const text = document.createElement('span');
        text.textContent = heading.textContent.trim();
        link.append(number, text);
        links.append(link);
      });
      toc.hidden = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', () => enhance());
})();
